import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import Select from "react-select";
import { getMiniLocations } from "../../../store/Mini/actions";
import { getMiniSubLocations } from "../../../store/Mini/actions";
import {
  getORDERLocations,
  model_open,
  model_close,
  InputChangeValue,
  SelecteChangeValue,
  ORDERlocationAdd,
  LocationImage,
  LocationImage2,
  LocationImage3,
  getOrderLocationRowData,
  clearOrderLocationData,
} from "../../../store/Masters/OrderLocations/action";
import swal from "sweetalert";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import { CustomInput } from "reactstrap";

class AddOrderLocations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leftSideBarType: "icon",
      bymodel: false,
      // Attachment 1
      imagePreviewUrl: null,
      fileType: null,
      fileName: null,
      // Attachment 2
      imagePreviewUrl2: null,
      fileType2: null,
      fileName2: null,
      // Attachment 3
      imagePreviewUrl3: null,
      fileType3: null,
      fileName3: null,
      // Checkboxes for each attachment
      sendFlag1: true,
      sendFlag2: false,
      sendFlag3: false,
    };
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getORDERLocations({
      ...this.props.params,
      page: 1,
      search: "",
    });

    this.setState({
      bymodel: this.props.CPmodel ? true : false,
    });

    this.props.getMiniLocations();

    let id;
    if (this.props.CPmodel) {
      id = this.props.openId;
    } else {
      id = this.props.match?.params?.id;
    }

    if (id && id !== "0") {
      this.setState({ id: parseInt(id, 10) });
      this.props.getOrderLocationRowData(id, this.props.history);
    } else {
      this.setState({ id: 0 });
      this.props.clearOrderLocationData();
    }
  }

  componentDidUpdate(prevProps) {
    const rd = this.props.rowdata;
    const prevRd = prevProps.rowdata;

    // Only run when rowdata actually changes
    if (prevRd === rd) return;

    const updates = {};

    // Reset attachment previews when server images change
    if (prevRd?.image !== rd?.image) {
      updates.fileType = null;
      updates.imagePreviewUrl = null;
      updates.fileName = null;
    }
    if (prevRd?.image2 !== rd?.image2) {
      updates.fileType2 = null;
      updates.imagePreviewUrl2 = null;
      updates.fileName2 = null;
    }
    if (prevRd?.image3 !== rd?.image3) {
      updates.fileType3 = null;
      updates.imagePreviewUrl3 = null;
      updates.fileName3 = null;
    }

    // Restore checkbox flags
    if (rd?.send_flag1 !== undefined) updates.sendFlag1 = !!rd.send_flag1;
    if (rd?.send_flag2 !== undefined) updates.sendFlag2 = !!rd.send_flag2;
    if (rd?.send_flag3 !== undefined) updates.sendFlag3 = !!rd.send_flag3;

    // Set preview from server URL for attachment 1
    if (
      !this.state.fileType &&
      !updates.fileType &&
      typeof rd?.image === "string" &&
      rd.image.trim() !== ""
    ) {
      const url = rd.image.trim().toLowerCase();
      if (url.endsWith(".pdf")) {
        updates.fileType = "pdf";
        updates.fileName = rd.image.split("/").pop();
        updates.imagePreviewUrl = null;
      } else {
        updates.fileType = "image";
        updates.imagePreviewUrl = rd.image;
      }
    }

    // Set preview from server URL for attachment 2
    if (
      !this.state.fileType2 &&
      !updates.fileType2 &&
      typeof rd?.image2 === "string" &&
      rd.image2.trim() !== ""
    ) {
      const url = rd.image2.trim().toLowerCase();
      if (url.endsWith(".pdf")) {
        updates.fileType2 = "pdf";
        updates.fileName2 = rd.image2.split("/").pop();
        updates.imagePreviewUrl2 = null;
      } else {
        updates.fileType2 = "image";
        updates.imagePreviewUrl2 = rd.image2;
      }
    }

    // Set preview from server URL for attachment 3
    if (
      !this.state.fileType3 &&
      !updates.fileType3 &&
      typeof rd?.image3 === "string" &&
      rd.image3.trim() !== ""
    ) {
      const url = rd.image3.trim().toLowerCase();
      if (url.endsWith(".pdf")) {
        updates.fileType3 = "pdf";
        updates.fileName3 = rd.image3.split("/").pop();
        updates.imagePreviewUrl3 = null;
      } else {
        updates.fileType3 = "image";
        updates.imagePreviewUrl3 = rd.image3;
      }
    }

    // Single setState call — avoids multiple re-renders
    if (Object.keys(updates).length > 0) {
      this.setState(updates);
    }
  }

  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }

  handleFileChange(e, attachmentNum) {
    e.preventDefault();
    const file = e.target.files[0];

    const stateKeys = {
      1: {
        preview: "imagePreviewUrl",
        type: "fileType",
        name: "fileName",
        action: this.props.LocationImage,
      },
      2: {
        preview: "imagePreviewUrl2",
        type: "fileType2",
        name: "fileName2",
        action: this.props.LocationImage2,
      },
      3: {
        preview: "imagePreviewUrl3",
        type: "fileType3",
        name: "fileName3",
        action: this.props.LocationImage3,
      },
    };
    const keys = stateKeys[attachmentNum];

    if (!file) {
      keys.action({});
      this.setState({ [keys.preview]: null, [keys.type]: null });
      return;
    }

    const fileType = file.type;
    keys.action(file);

    if (fileType.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({ [keys.preview]: reader.result, [keys.type]: "image" });
      };
      reader.readAsDataURL(file);
    } else if (fileType === "application/pdf") {
      this.setState({
        [keys.preview]: null,
        [keys.type]: "pdf",
        [keys.name]: file.name,
      });
    } else {
      swal("Only images or PDF files are allowed!", { icon: "error" });
      this.setState({ [keys.preview]: null, [keys.type]: null });
    }
  }

  handleValidSubmit() {
    var data = this.props.rowdata;

    if (!data.location_id) {
      swal("Please select a Location!", { icon: "error" });
      return;
    }
    if (!data.sublocation_id) {
      swal("Please select a Sub Location!", { icon: "error" });
      return;
    }
    if (!data.name) {
      swal("Please enter a Location Name!", { icon: "error" });
      return;
    }

    this.props.ORDERlocationAdd({
      data: {
        ...data,
        send_flag1: this.state.sendFlag1,
        send_flag2: this.state.sendFlag2,
        send_flag3: this.state.sendFlag3,
      },
      image: this.props.image,
      image2: this.props.image2,
      image3: this.props.image3,
      fileType: this.state.fileType,
      fileType2: this.state.fileType2,
      fileType3: this.state.fileType3,
      LoId: data.id ? data.id : 0,
      history: this.props.history,
      model: this.state.bymodel ? true : false,
    });
  }

  renderFilePreview(fileType, previewUrl, fileName, existingImage) {
    const boxStyle = {
      height: "200px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      border: "1px solid #dee2e6",
      borderRadius: "4px",
      backgroundColor: "#f8f9fa",
      cursor: "pointer",
      overflow: "hidden",
    };

    if (fileType === "image" && previewUrl) {
      return (
        <div style={boxStyle}>
          <img
            alt="Preview"
            src={previewUrl}
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      );
    } else if (fileType === "pdf") {
      return (
        <div style={boxStyle}>
          <i className="ri-file-pdf-line ri-5x text-danger"></i>
          <span
            className="font-size-14 mt-2 text-center px-2"
            style={{ wordBreak: "break-all" }}
          >
            {fileName}
          </span>
        </div>
      );
    } else if (
      typeof existingImage === "string" &&
      existingImage.trim() !== "" &&
      !existingImage.trim().toLowerCase().endsWith(".pdf")
    ) {
      return (
        <div style={boxStyle}>
          <img
            alt="Existing"
            src={existingImage}
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      );
    } else {
      return (
        <div style={{ ...boxStyle, border: "2px dashed #dee2e6" }}>
          <i className="ri-upload-cloud-line ri-5x text-muted"></i>
          <span className="font-size-14 text-muted mt-2">
            Select File (Image or PDF)
          </span>
        </div>
      );
    }
  }

  render() {
    var data = this.props.rowdata;

    const attachments = [
      {
        num: 1,
        label: "Attachment 1",
        fileType: this.state.fileType,
        previewUrl: this.state.imagePreviewUrl,
        fileName: this.state.fileName,
        existingImage: data?.image,
        inputId: "productCustomFile1",
        flagKey: "sendFlag1",
        flagLabel: "Send Flag 1",
        remarksName: "remarks",
        remarksValue: data?.remarks,
        remarksPlaceholder: "Enter remarks",
      },
      {
        num: 2,
        label: "Attachment 2",
        fileType: this.state.fileType2,
        previewUrl: this.state.imagePreviewUrl2,
        fileName: this.state.fileName2,
        existingImage: data?.image2,
        inputId: "productCustomFile2",
        flagKey: "sendFlag2",
        flagLabel: "Send Flag 2",
        remarksName: "remarks2",
        remarksValue: data?.remarks2,
        remarksPlaceholder: "Enter remarks 2",
      },
      {
        num: 3,
        label: "Attachment 3",
        fileType: this.state.fileType3,
        previewUrl: this.state.imagePreviewUrl3,
        fileName: this.state.fileName3,
        existingImage: data?.image3,
        inputId: "productCustomFile3",
        flagKey: "sendFlag3",
        flagLabel: "Send Flag 3",
        remarksName: "remarks3",
        remarksValue: data?.remarks3,
        remarksPlaceholder: "Enter remarks 3",
      },
    ];

    return (
      <React.Fragment>
        <Modal isOpen={true} backdrop="static" centered size="xl">
          <ModalHeader toggle={() => this.props.history.goBack()}>
            {this.state.id && this.state.id !== 0
              ? "EDIT ORDER LOCATION"
              : "ADD ORDER LOCATION"}
          </ModalHeader>

          <AvForm
            className="form-horizontal"
            onValidSubmit={this.handleValidSubmit}
          >
            <ModalBody>
              <Row className="justify-content-center">
                <Col md={10}>
                  <Row className="justify-content-center">
                    <Col md={9}>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="Location_id_select"
                            className="col-form-label float-right"
                          >
                            Select Location
                          </Label>
                        </Col>
                        <Col md={8}>
                          <Select
                            id="Location_id_select"
                            name="Location_id_select"
                            classNamePrefix="select2-selection"
                            isClearable={
                              this.props.rowdata?.locationsLabel ? true : false
                            }
                            options={this.props.locationslist.map(
                              (item, index) => ({
                                label: item.name,
                                value: item.id,
                              }),
                            )}
                            value={{
                              label:
                                data.locationsLabel == null
                                  ? "select Location"
                                  : data.locationsLabel,
                              value: data.location_id,
                            }}
                            onChange={(e) => {
                              this.props.getMiniSubLocations(e.value);
                              this.props.SelecteChangeValue({
                                key: "locationsLabel",
                                label: e?.label,
                                key2: "location_id",
                                value: e?.value,
                              });
                            }}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="sublocation_id_select"
                            className="col-form-label float-right"
                          >
                            Sub Location
                          </Label>
                        </Col>
                        <Col md={8}>
                          <Select
                            id="sublocation_id_select"
                            name="sublocation_id_select"
                            classNamePrefix="select2-selection"
                            isDisabled={!this.props.rowdata.location_id}
                            options={this.props.sublocationslist?.map(
                              (item, index) => ({
                                label: item.name,
                                value: item.id,
                              }),
                            )}
                            value={
                              data.sublocation_id
                                ? {
                                    label: data.sublocationLabel,
                                    value: data.sublocation_id,
                                  }
                                : null
                            }
                            onChange={(e) => {
                              this.props.SelecteChangeValue({
                                key: "sublocationLabel",
                                label: e?.label,
                                key2: "sublocation_id",
                                value: e?.value,
                              });
                            }}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="LocationName"
                            className="col-form-label float-right"
                          >
                            Order Location Name
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="name"
                            type="text"
                            value={data.name}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="LocationName"
                            placeholder="Enter Location Name"
                            errormessage=" Please provide a valid Location Name"
                            validate={{
                              required: {
                                value: true,
                              },
                            }}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup>
                        <AvField
                          className="form-control"
                          type="hidden"
                          value={data.id}
                          id="id"
                          name="id"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* 3 Attachments in a row */}
                  <Row>
                    {attachments.map((att) => (
                      <Col md={4} key={att.num}>
                        <FormGroup className="mb-2">
                          <Label className="col-form-label font-weight-bold">
                            {att.label}
                          </Label>
                          <div className="product-detail">
                            <div className="mt-1 align-items-center">
                              <label
                                htmlFor={att.inputId}
                                style={{
                                  display: "block",
                                  width: "100%",
                                  cursor: "pointer",
                                }}
                              >
                                {this.renderFilePreview(
                                  att.fileType,
                                  att.previewUrl,
                                  att.fileName,
                                  att.existingImage,
                                )}
                              </label>
                              <div style={{ width: "100%" }}>
                                <CustomInput
                                  type="file"
                                  className="file-upload"
                                  id={att.inputId}
                                  accept="image/*,application/pdf"
                                  multiple={false}
                                  onChange={(e) =>
                                    this.handleFileChange(e, att.num)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          {/* Checkbox for send flag — only one can be true */}
                          <div className="mt-2">
                            <Label check className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                className="mr-2"
                                checked={this.state[att.flagKey]}
                                disabled={
                                  !this.state[att.flagKey] &&
                                  (this.state.sendFlag1 ||
                                    this.state.sendFlag2 ||
                                    this.state.sendFlag3)
                                }
                                onChange={(e) =>
                                  this.setState({
                                    [att.flagKey]: e.target.checked,
                                  })
                                }
                              />{" "}
                              {att.flagLabel}
                            </Label>
                          </div>
                          {/* Remarks field under checkbox */}
                          <div className="mt-2">
                            <AvField
                              name={att.remarksName}
                              type="text"
                              value={att.remarksValue || ""}
                              onChange={this.ChangeHandeler}
                              className="form-control"
                              id={att.remarksName}
                              placeholder={att.remarksPlaceholder}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  type="button"
                  className="btn btn-danger"
                  color="light"
                  onClick={() => this.props.history.goBack()}
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary"
                  color="primary"
                >
                  Save
                </Button>
              </ModalFooter>
            </ModalBody>
          </AvForm>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { locationslist, sublocationslist } = state.Mini;
  const { model, rowdata, image, image2, image3 } = state.orderLocations;
  return {
    locationslist,
    model,
    rowdata,
    sublocationslist,
    image,
    image2,
    image3,
  };
};

export default connect(mapStatetoProps, {
  getMiniLocations,
  getMiniSubLocations,
  getORDERLocations,
  InputChangeValue,
  SelecteChangeValue,
  ORDERlocationAdd,
  model_open,
  model_close,
  LocationImage,
  LocationImage2,
  LocationImage3,
  getOrderLocationRowData,
  clearOrderLocationData,
})(AddOrderLocations);
